import React from "react";
import { X, Shield, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const SettingsPanel = ({ isOpen, onClose }) => {
	const navigate = useNavigate();

	const handlePrivacyClick = () => {
		onClose();
		navigate("/privacy-policy", { state: { from: "settings" } });
	};

	return (
		<>
			{/* Backdrop */}
			<div
				className={`fixed inset-0 bg-black/20 dark:bg-black/40 transition-opacity duration-300 z-[100]
          ${isOpen ? "opacity-100" : "opacity-0 pointer-events-none"}`}
				onClick={onClose}
			/>

			{/* Panel */}
			<div
				className={`fixed inset-y-0 right-0 w-full xs:max-w-[360px] bg-white dark:bg-gray-900 
          shadow-lg transform transition-transform duration-300 ease-in-out z-[101]
          ${isOpen ? "translate-x-0" : "translate-x-full"}`}
			>
				<div className="flex flex-col h-full">
					{/* Header */}
					<div className="flex items-center justify-between p-4 border-b dark:border-gray-800">
						<h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
							Settings
						</h2>
						<button
							onClick={onClose}
							className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition-colors duration-200"
							aria-label="Close settings"
						>
							<X className="w-5 h-5 text-gray-600 dark:text-gray-400" />
						</button>
					</div>

					{/* Content */}
					<div className="flex flex-col flex-1 h-0">
						{/* Main settings content area */}
						<div className="flex-1 overflow-y-auto p-4">
							<h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-3">
								Settings
							</h3>
							<div className="text-sm text-gray-400 dark:text-gray-500 italic">
								More settings coming soon...
							</div>
						</div>

						{/* Footer with Privacy Policy */}
						<div className="p-4 border-t dark:border-gray-800 mt-auto">
							<button
								onClick={handlePrivacyClick}
								className="w-full flex items-center justify-between p-3 hover:bg-gray-50 dark:hover:bg-gray-800 rounded-lg transition-colors duration-200"
							>
								<div className="flex items-center space-x-3">
									<Shield className="w-5 h-5 text-gray-600 dark:text-gray-400" />
									<span className="text-gray-700 dark:text-gray-300">
										Privacy Policy
									</span>
								</div>
								<ChevronRight className="w-5 h-5 text-gray-400" />
							</button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default SettingsPanel;
